import $ from "jquery";

$(".footer-wrapper").find("ul").hide();
$(".mobilejs").click(function () {
    $(this).toggleClass("active");
    $(this).next("ul").slideToggle();
});

let searchTrigger = document.querySelectorAll(".trigger-search"),
    searchWrapper = document.querySelector(".search-wrapper"),
    searchInput = document.querySelector(".search-input"),
    searchResults = document.querySelector(".search-results");


document.addEventListener("click", function (e) {
    if (
        e.target.classList.contains("close-search") ||
        e.target.classList.contains("search-wrapper")
    ) {
        searchWrapper.classList.add("!hidden");
    }
});

function openIosKeyboard() {
    const input = document.createElement("input");
    input.setAttribute("type", "text");
    input.setAttribute("style", "position: fixed; top: -100px; left: -100px;");
    document.body.appendChild(input);
    input.focus();
    // it's safe to remove the fake input after a 30s timeout
    setTimeout(() => {
        document.body.removeChild(input);
    }, 30 * 1000);
}